import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { HeatmapQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';
import { buildHeatmapRegions } from './buildHeatmapRegions';

export function mapHeatmapQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell
): HeatmapQuestion {
  const metadata = raw.surveyHeatmapMetadata;
  const asset = raw.questionAssets?.[0];
  const imageUrl = asset?.source || asset?.previewImageUrl || '';

  const rawMax = metadata?.totalClickAllowed ?? 20;
  const maxClicksAllowed = Math.min(20, Math.max(1, rawMax));

  const { regions, referenceWidth, referenceHeight } = buildHeatmapRegions(
    metadata?.heatmapRegions ?? [],
    metadata?.imageWidth ?? 0,
    metadata?.imageHeight ?? 0
  );

  return {
    ...shell,
    type: QUESTION_TYPE.HEATMAP,
    imageUrl,
    regions,
    maxClicksAllowed,
    referenceWidth,
    referenceHeight,
  };
}
